// src/utils/attribution.js
//
// Captures which social/ad channel a visitor arrived from (utm_* params,
// Meta/Google click ids) so it can be attached to the signup payload and
// stored against the user record for conversion-by-campaign reporting.
//
// Model: last-touch-with-params. A visit that carries tracking params
// overwrites whatever was stored before (crediting the campaign that most
// recently brought them back); a plain visit with no params leaves the
// existing attribution untouched instead of erasing it.

const STORAGE_KEY = "hervest_attribution";
const TRACKED_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
];

export const captureAttribution = () => {
  if (typeof window === "undefined") return;

  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    TRACKED_PARAMS.forEach((key) => {
      const value = params.get(key);
      if (value) found[key] = value;
    });

    if (Object.keys(found).length === 0) return;

    const attribution = {
      ...found,
      referrer: document.referrer || null,
      landing_page: window.location.href,
      captured_at: new Date().toISOString(),
    };

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (error) {
    console.warn("Failed to capture attribution:", error);
  }
};

export const getAttribution = () => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};
